import { ACLEntityTypeFieldDto } from './aclEntityTypeField.dto';
import { ACLInheritDataStepDto } from './aclInheritDataStep.dto';
import { BaseDto } from './base.dto';

export class ACLInheritDataStepFieldCopyDto extends BaseDto{  
    step: ACLInheritDataStepDto;
    sourceField: ACLEntityTypeFieldDto;
    targetField: ACLEntityTypeFieldDto;
    
}